import Vue from 'vue';
import Confirm from '../../components/confirmation/confirm.vue';
import ChartDoughnut from "../../components/ChartDoughnut/ChartDoughnut.vue";
import ChartBar from "../../components/ChartBar/ChartBar.vue";
// import MainChartExample from "../charts/MainChartExample.vue";
import Table from "../../components/table/table.vue";
import JobPost from "../../components/job_post/job_post.vue";
import SubjectTable from "../../components/subjectTable/subjectTable.vue";
import ActivityFeed from "../../components/Feed/feed.vue";
import StudentLocation from "../../components/Student_location/Student_location.vue";
import ChartLine from "../../components/ChartLine/ChartLineBase2.vue"

export default Vue.extend({
    components: {
        Confirm,
        ChartDoughnut,
        ChartBar,
        // MainChartExample,
        Table,
        SubjectTable,
        ActivityFeed,
        StudentLocation,
        JobPost,
        ChartLine
    },

    data: () => ({
      items: ['30 days', '15 days', '10 days', '5 days'],
      items1: ['Product Sales Specialist', 'Frontend Developer', 'Backend Developer', 'Atomation Tester'],
      cards: [
        // { title: 'Data Science', value: '85%', icon: 'mdi-chart-bar' },
        // { title: 'English', value: '82%', icon: 'mdi-book' },
        // { title: 'Analytical Ability', value: '83%', icon: 'mdi-magnify-plus'  },
        // { title: 'Programming', value: '85%', icon: 'mdi-buffer' },
        // { title: 'Networking', value: '82%', icon: 'mdi-cast-connected' },

      ],
      id : 0,
      allSubject : [],
      scoreItem: [
        { 'value' : '0 - 20',
          'sRange': 'range1' 
        },
        { 'value' : '21 - 40',
          'sRange': 'range2'
        },
        { 'value' : '41 - 50',
          'sRange': 'range3'
        },
        { 'value' : '61 - 80',
          'sRange': 'range4'
        },
        { 'value' : '81 - 100',
            'sRange': 'range5' 
        }
      ],
      sRange:'',
      testName :'',
      noOftests : [{
          'testValue' : '0 - 5',
          'testName' : 'range1'
        },
        {
          'testValue' : '6 - 10',
          'testName' : 'range2'
        },
        {
          'testValue' : '11 - 15',
          'testName' : 'range3'
        },
        {
          'testValue' : '16 - 20',
          'testName' : 'range4'
        },
        {
          'testValue' : '20 Above',
          'testName' : 'range5'
        }
      ],
      sortBy: "name",
      sortDirection: "asc",
      result :[],
      jobs : [],
      show: true,
      jobPost_number : 0,
      candidates_applied_number : 0,
      candidates_invited_number : 0,
      candidates_shrtlisted_number : 0,
      avgData : 0,
      dataLoading : false,
      englishValue : 0,
      dataScienceValue : 0,
      netWValue:0,
      analyticalValue : 0,
      psValue : 0,
      message : '',
      snackbar : false,
      selectedCandidate:[],
      headers: [
        {
          text: 'Student Name',
          align: 'start',
          sortable: false,
          value: 'studentName',
        },
        { text: 'Last Test Taken', value: 'lastTestTaken' },
        // { text: 'Average', value: 'Average' },
        { text: 'Percentile Score', value: 'Score' },
      ],

      // header: [
      //   {
      //     text: 'Job Title',
      //     align: 'start',
      //     sortable: false,
      //     value: 'Title',
      //   },
      //   { text: 'Invited Candidate', value: 'Invited' },
      //   { text: 'Applied Candidate', value: 'Applied' },
      //   { text: 'Interview Process', value: 'Interview' },
        
      // ],
      // desserts: [
      //   {
      //     Title: '{{job_number.job_name}}',
      //     Invited: '{{job_number.total_invited}}',
      //     Applied: '{{job_number.total_applied}}',
      //     Interview: '{{job_number.total_invited_for_interview}}',
      //   },
        
      // ],
    }),

    created(){
      let admin = localStorage.getItem("admin_name");
      this.adminName = admin.substring(0, admin.lastIndexOf("@"));
      console.log("data", this.adminName);
     
      this.dashboardData();
      this.recent_job();
    },
    computed: {
      sortedProducts: function () {
        return this.products.sort((p1, p2) => {
          let modifier = 1;
          if (this.sortDirection === "desc") modifier = -1;
          if (p1[this.sortBy] < p2[this.sortBy]) return -1 * modifier;
          if (p1[this.sortBy] > p2[this.sortBy]) return 1 * modifier;
          return 0;
        });
      },
  
      filteredJobs() {
        return this.search
          ? this.jobs.filter((job) => {
              return job.job_title
                .toLowerCase()
                .includes(this.search.toLowerCase());
            })
          : this.jobs;
      },
    },
    methods : {
      orderByCond(what, cond) {
        console.log(what);
        this.sortCond = !cond;
        return this.filteredJobs.sort((secondEl, firstEl) => {
          return this.sortCond 
          ? secondEl.number_of_candidates_applied - firstEl.number_of_candidates_applied 
          : firstEl.number_of_candidates_applied - secondEl.number_of_candidates_applied;
        });
      },

      sort: function (s) {
        if (s === this.sortBy) {
          this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
        }
        this.sortBy = s;
      },

      async dashboardData(){
        this.dataLoading = true;
        let token =  localStorage.getItem("jwt");
        let userId =  localStorage.getItem("userId");
        
        if (token) { 
          const auth = {
            headers: {authorization: token} 
          }   
          let resp = await this.$http.get('job/getRecruiterDashboardAnalytics/'+userId, auth)
          console.log("data",resp);
          if (resp.status === 200 && resp.data.message){
            this.jobPost_number= resp.data.data.number_of_posted_jobs;
            this.candidates_applied_number= resp.data.data.number_of_candidates_applied;
            this.candidates_invited_number= resp.data.data.number_of_candidates_invited;
            this.candidates_shrtlisted_number= resp.data.data.number_of_candidates_shortlisted;
          }
        }  
          this.dataLoading = false;
      },

      async recent_job(){
        let token =  localStorage.getItem("jwt");
        let userId =  localStorage.getItem("userId");
        this.dataLoading = true;
        if (token && userId) { 
          const auth = {
            headers: {authorization: token} 
          }  
          let resp = await this.$http.get('job/fetchJobsByRecruiter/'+userId, auth)
          console.log(resp);
          if (resp.status === 200 && resp.data.message === "Jobs found"){
            
            if (resp.data.jobs.length>4) {
              for (let i = 0; i < 4; i++) {
                this.jobs.push(resp.data.jobs[i]);
              }
            } else {
              this.jobs = resp.data.jobs;
            }           
            console.log(this.jobs);
          }
          this.dataLoading = false;
        }
      },



     
      all_job_view(){
        // this.$router.push('/all_job_listings');
        this.$router.push({ name: 'all job'})

      },
      go_to_talent(id){
        this.$router.push({ name: 'recomended_talent', params: { id: id } })
      },

      go_to_applicants(id){
        this.$router.push({ name: 'applied_candidate', params: { id: id } })
      },

      go_to_invite(id){
        this.$router.push({ name: 'invite_talent', params: { id: id } })
      },

      go_to_shorListed(id){
        this.$router.push({ name: 'shortlist_candidate', params: { id: id } })
      },

      go_to_jdetails(jid){
        this.$router.push({ name: 'job-application-details', params: { id: jid } })
      },

      edit(jid){
        this.$router.push({ name: 'update_job-application', params: { id: jid } })
      },
      async job_delete(id){
        try {
          //  await this.alertMsg('Remove Job','info','Are you sure?',id)
           this.$swal({
            title: 'Remove Application',
            text: 'Are you sure?',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText:'Cancel',
            customClass: 'swal-title-jobapplication'
        }).then((result) => {
          if (result.isConfirmed) {
            this.delete_job(id);
          }
         
        })

        }catch(error){}
      },
      details(jobid){
        this.$router.push({ name: 'job-application-details', params: { id: jobid } })
      },
    
      async delete_job(id){
        let token = localStorage.getItem("jwt");
        let userId = localStorage.getItem("userId");

        console.log(token);
        console.log(userId);

        if (token && userId) { 
          const auth = {
            headers: {authorization: token} 
          }  
          let res = await this.$http.post('/job/removeJob',{
              job_id: id,
              user_id: userId
          },auth);
          if (res.status === 200 && res.data.message === "Job removed successfully") {
            console.log("jhjhggyugyggygy");
            this.snackbar = true;
            this.showMessage = 'Removed Successfully.'
            this.recent_job();
          } else {
            this.snackbar = true;
            this.showMessage = 'Something wrong! Please try again.'
          }
        }
      }
      
      
    }
})




